// extracted by mini-css-extract-plugin
module.exports = {"visibilityButton":"HistoryModal_visibilityButton__ZnuOA","modalTitle":"HistoryModal_modalTitle__3fdNa","viewButtonColumn":"HistoryModal_viewButtonColumn__3xQ6g"};